import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { IContractStructure } from './IContractStructure';
import { IEntityFilter } from './IEntityFilter';
import { ICustomer } from './ICustomer';
import { IContractType } from './IContractType';
import { map, tap } from 'rxjs/operators';
import { IGenericResponse } from '../shared';

@Injectable({
  providedIn: 'root'
})

export class ContractStructureService {

  constructor(@Inject(HttpClient) private http: HttpClient,
    @Inject(LoggingService) private log: LoggingService) { }

  private url = `${environment.apiLocation}/EntityFilter`;
  private customerurl = `${environment.apiLocation}/Customer`;
  private contracttypeurl = `${environment.apiLocation}/ContractType`;
  private uri = `${environment.apiLocation}/ContractStructure`;

  public getEntityFilter (): Observable<Array<IEntityFilter>> {
    return this.http.get<Array<IEntityFilter>>(this.url)
      .pipe(res => {
        this.log.verbose({ type: 'CustomerJobComponent:getEntityFilter:reponse', res });
        return res;
      });
  }

  public getCustomers (): Observable<Array<ICustomer>> {
    return this.http.get<Array<ICustomer>>(this.customerurl)
      .pipe(res => {
        this.log.verbose({ type: 'CustomerJobComponent:getCustomers:reponse', res });
        return res;
      });
  }

  public getContractTypes (): Observable<Array<IContractType>> {
    return this.http.get<Array<IContractType>>(this.contracttypeurl)
      .pipe(res => {
        this.log.verbose({ type: 'CustomerJobComponent:getContractTypes:reponse', res });
        return res;
      });
  }

  public getCustomerJobs (customers: Array<ICustomer>, filterid: IEntityFilter): Observable<Array<IContractStructure>> {
    return this.http.post<Array<IContractStructure>>(this.uri, { customerlist: customers, customerfilterid: filterid.FilterID })
      .pipe(res => {
        this.log.verbose({ type: 'CustomerJobComponent:getCustomerJobs:reponse', res });
        return res;
      });
  }

  public putContractStructure (contracts: Array<IContractStructure>): Observable<IGenericResponse<IContractStructure>> {
    this.log.debug({ type: 'ContractStructureService:putContractStructure', contracts });
    this.log.verbose(JSON.stringify({ contractlist: contracts }));
    return this.http.put<IGenericResponse<IContractStructure>>(this.uri, { ContractStructureList: contracts })
      .pipe(res => {
        this.log.verbose({ type: 'ContractStructureService:putContractStructure:reponse', res });
        return res;
      });
  }
}
